export default __webpack_public_path__ + "static/media/HelpDesk1.523f5787.svg";